import {
	defAction
}from "../../../../helpers/defaultAction"
import {
	reDistrictConstants
}from "./constants"
import api from './api'

export const reDistrictActions = {
	getPaged,
	getPagedAudit,
	getPagedAll,
	getList,
	create,
	remove,
	update,
	restore,
	clear,
	getListActualByRegion
}

function getPaged(values){
	const dispatchObj = {
		constants : reDistrictConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAudit(values){
	const dispatchObj = {
		constants : reDistrictConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reDistrictConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reDistrictConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reDistrictConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reDistrictConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reDistrictConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reDistrictConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reDistrictConstants.CLEAR
	})
}

function getListActualByRegion(values){
	const dispatchObj = {
		constants : reDistrictConstants.getListActualByRegion,
		service   : {
			func   : api.getListActualByRegion,
			params : values
		}
	}
	return defAction(dispatchObj)
}